











































import { ActionType } from '@/store/types'
import Vue from 'vue'
export default Vue.extend({
  name: 'Verify',
  props: {
    code: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
      res: null,
    }
  },
  async created() {
    this.res = await this.$store.dispatch(ActionType.REGISTER_USER, this.code)
    this.isLoading = false
  },
})
